import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/skeleton/Skeleton.tsx
const SkeletonBar = ({ fill = "md", orientation = "horizontal", variant = "pulse", className, ...rest }) => {
	return /* @__PURE__ */ jsx("div", {
		className: twMerge("rounded-sm bg-gray-200", variant === "pulse" && "animate-pulse", orientation === "horizontal" ? "h-2" : "w-2", getFillByOrientation(orientation)(fill), className),
		tabIndex: -1,
		"aria-hidden": true,
		...rest
	});
};
const SkeletonParagraph = () => {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "sm" }),
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "md" }),
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "lg" }),
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "xl" }),
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "sm" }),
			/* @__PURE__ */ jsx(SkeletonBar, { fill: "md" })
		]
	});
};
const SkeletonBigText = () => {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-4",
		children: [/* @__PURE__ */ jsx(SkeletonBar, { className: "h-5" }), /* @__PURE__ */ jsx(SkeletonBar, {
			fill: "sm",
			className: "h-3"
		})]
	});
};
const getFillByOrientation = (orientation) => orientation === "horizontal" ? getHorizontalFill : getVerticalFill;
const getHorizontalFill = (fill) => {
	switch (fill) {
		case "xs": return "w-1/5";
		case "sm": return "w-2/5";
		case "md": return "w-3/5";
		case "lg": return "w-3/4";
		case "xl": return "w-11/12";
		case "full": return "w-full";
	}
};
const getVerticalFill = (fill) => {
	switch (fill) {
		case "xs": return "h-1/5";
		case "sm": return "h-2/5";
		case "md": return "h-3/5";
		case "lg": return "h-3/4";
		case "xl": return "h-4/5";
		case "full": return "h-full";
	}
};
const Bar = SkeletonBar;
const BigText = SkeletonBigText;
const Paragraph = SkeletonParagraph;
//#endregion
export { Bar, BigText, Paragraph, SkeletonBar, SkeletonBigText, SkeletonParagraph };
